export const INCOMING_REBUZZ_OPTIONS = {
  PAID_CONTENT: 'paidContent',
  FREE_CONTENT: 'freeContent',
  PAID_PROMOTION: 'paidPromotion',
  FREE_PROMOTION: 'freePromotion',
  ENDORSEMENT: 'endorsement',
};
